import { Icon } from '../../../components/Icons.jsx';
import { PLATFORM_COLORS, PLATFORM_LABELS } from './platformLabels';

const ICON_NAMES = {
  linkedin: 'linkedin',
  instagram: 'instagram',
  telegram: 'telegram',
  tiktok: 'tiktok',
  facebook: 'facebook',
  x: 'xBrand',
};

export function PlatformIcon({ platform, size = 18, withColor = true, className = '' }) {
  const name = ICON_NAMES[platform];
  const color = withColor ? PLATFORM_COLORS[platform] : 'currentColor';
  if (!name) {
    return (
      <span
        aria-label={PLATFORM_LABELS[platform] ?? platform}
        className={`inline-flex items-center justify-center font-semibold ${className}`}
        style={{ width: size, height: size, color }}
      >
        {(platform?.[0] ?? '?').toUpperCase()}
      </span>
    );
  }
  return (
    <span
      aria-label={PLATFORM_LABELS[platform] ?? platform}
      className={`inline-flex items-center justify-center ${className}`}
      style={{ color }}
    >
      <Icon name={name} size={size} stroke={1.7} />
    </span>
  );
}
